import { ReactElement } from 'react';
import { useTheme, TableContainer, TableHead, TableCell, TableBody } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CalculationResults } from 'types/domainTypes';
import { ResultsPanelAccordion } from 'components/ResultsPanelAccordion/ResultsPanelAccordion';
import { SupportReactionResultsRow } from 'components/SupportReactionResultsRow/SupportReactionResultsRow';
import { ResultsPanelTable } from './CalculationResultsPanel';
import { TableRow } from 'components/atoms/TableRow';

interface Props {
  result: CalculationResults;
  expanded: boolean;
  onClick: () => void;
}

export function MinimumReactionView({ result, expanded, onClick }: Props): ReactElement {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <ResultsPanelAccordion
      header={
        result.hasFastenerResults
          ? t('calculation-page.results-panel.minimum-reaction.header-fastener-results')
          : t('calculation-page.results-panel.minimum-reaction.header')
      }
      greyOutHeader={result.hasFastenerResults ? '' : t('calculation-page.results-panel.minimum-reaction.header-per-support')}
      expanded={expanded}
      onClick={onClick}
      data-testid="minimum-reaction-accordion"
    >
      <TableContainer>
        <ResultsPanelTable>
          <TableHead>
            <TableRow sx={{ '& th': { color: theme.palette.grey[500] } }}>
              <TableCell align="left">{t('calculation-page.results-panel.minimum-reaction.label-supports')}</TableCell>
              <TableCell align="left">{t('calculation-page.results-panel.minimum-reaction.label-min-reaction')}</TableCell>
              {result.hasFastenerResults && (
                <TableCell align="left">{t('calculation-page.results-panel.minimum-reaction.label-number-of-fasteners')}</TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {result.supports.map((supportReaction, idx) => (
              <SupportReactionResultsRow key={idx} supportReaction={supportReaction} showFasteners={result.hasFastenerResults} />
            ))}
          </TableBody>
        </ResultsPanelTable>
      </TableContainer>
    </ResultsPanelAccordion>
  );
}
